import { Box, Button, Stack } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import Modal from "../../../App/Components/Modal/Modal";
import { useBulkUpsertCandidateTags } from "../../../App/Queries/CandidateQueries";
import { useNotification } from "../../../App/State/Hooks/notificationHooks";
import { TagAutoComplete } from "../../../CandidateProfile/Components/CandidateAccordions/Subcomponents/CandidateTags";

export default function BulkTagModal({
  selectedCandidates,
  selectedCount,
}: {
  selectedCandidates: string[];
  selectedCount: number;
}) {
  const [tags, setTags] = useState<string[]>([]);
  const [bulkAddTagsModalOpen, setBulkAddTagsModalOpen] = useState<boolean>(false);
  const { mutateAsync: saveCandidateAsync, isLoading } = useBulkUpsertCandidateTags();
  const { displaySuccess, displayError } = useNotification();

  const selectTags = useCallback((tag: string[]) => {
    setTags((t) => [...t, ...tag.filter((c) => !t.includes(c))]);
  }, []);
  const onDelete = useCallback((tag: string, isNew: boolean) => {
    setTags((t) => t.filter((c) => c !== tag));
  }, []);

  const saveTags = async () => {
    if (tags && selectedCount > 0) {
      await saveCandidateAsync(
        {
          candidateIds: selectedCandidates,
          clientId: "",
          tags: tags,
          userId: "",
        },
        {
          onSuccess: () => {
            displaySuccess("Tags added.");
            setBulkAddTagsModalOpen(false);
            setTags([]);
          },
          onError: () => {
            displayError("There was an error updating candidate tags.");
          },
        },
      );
    }
  };

  return (
    <>
      <Button
        data-test="bulk-tag-button"
        variant="text"
        disabled={selectedCount <= 0}
        onClick={() => setBulkAddTagsModalOpen(true)}
      >
        Add tags to {selectedCount} candidate(s)
      </Button>
      <Modal
        content={
          <Box data-test="bulk-candidate-tags">
            <TagAutoComplete
              disabled={isLoading}
              existingTags={tags}
              onDelete={onDelete}
              onSelect={selectTags}
            />
          </Box>
        }
        title="Add Candidate Tags"
        dataTestId="candidate-tag-add"
        footerContent={
          <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
            <Button
              data-test="bulk-tags-save-btn"
              color="primary"
              disabled={isLoading || !tags.length}
              variant="contained"
              onClick={(_ev) => saveTags()}
            >
              Save
            </Button>
            <Button color="info" variant="contained" onClick={() => setBulkAddTagsModalOpen(false)}>
              Close
            </Button>
          </Stack>
        }
        isOpen={bulkAddTagsModalOpen}
        handleCloseModal={() => setBulkAddTagsModalOpen(false)}
        size="md"
      />
    </>
  );
}
